export const LocalFileSystemID = 'file://';
export const FileStateAttr = Symbol.for('state');
export var FileState;
(function (FileState) {
    FileState["Creating"] = "creating";
    FileState["Renaming"] = "renaming";
})(FileState || (FileState = {}));
export const FileAttrsAttr = 'attributes';
export var SortOrder;
(function (SortOrder) {
    SortOrder["Asc"] = "asc";
    SortOrder["Desc"] = "desc";
})(SortOrder || (SortOrder = {}));
export var QueueType;
(function (QueueType) {
    QueueType["Copy"] = "copy";
    QueueType["Move"] = "move";
    QueueType["Download"] = "download";
    QueueType["Upload"] = "upload";
    QueueType["Remove"] = "remove";
})(QueueType || (QueueType = {}));
export var QueueEventType;
(function (QueueEventType) {
    QueueEventType["Start"] = "start";
    QueueEventType["Create"] = "create";
    QueueEventType["Update"] = "update";
    QueueEventType["Ask"] = "ask";
    QueueEventType["Complete"] = "complete";
})(QueueEventType || (QueueEventType = {}));
export var QueueActionType;
(function (QueueActionType) {
    QueueActionType["Skip"] = "skip";
    QueueActionType["Replace"] = "replace";
    QueueActionType["Rename"] = "rename";
})(QueueActionType || (QueueActionType = {}));
export var FailureType;
(function (FailureType) {
    FailureType["Unauthorized"] = "unauthorized";
    FailureType["ConfirmDeletion"] = "confirm-deletion";
    FailureType["ConfirmClear"] = "confirm-clear";
    FailureType["MissingDir"] = "missing-dir";
    FailureType["RemoteError"] = "remote-error";
    FailureType["APIError"] = "api-error";
    FailureType["Warning"] = "warning";
    FailureType["Info"] = "info";
    FailureType["UpdateAvailable"] = "update-available";
})(FailureType || (FailureType = {}));
export var MirrorEventType;
(function (MirrorEventType) {
    MirrorEventType["Create"] = "create";
    MirrorEventType["Syncing"] = "syncing";
    MirrorEventType["Complete"] = "complete";
})(MirrorEventType || (MirrorEventType = {}));
